module.exports = __webpack_public_path__ + "static/media/restaurant.8356fc1c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/restaurant.jpg
// module id = 825
// module chunks = 3